import env from 'constants/env';
import logoSource from '/static/assets/images/logo-white.png';
import {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import Button from 'ui/@_components/button-v2';
import BgGradientLeftIcon from 'ui/@_components/page-template/assets/bg-gradient-left.svg?react';
import BgGradientRightIcon from 'ui/@_components/page-template/assets/bg-gradient-right.svg?react';
import styles from './styles.module.scss';

interface Props {
  children: ReactNode;
}

const PublicMeetingShell = ({children}: Props) => {
  const {t} = useTranslation('sense', {
    keyPrefix: 'meetings-v2.show.components.flow-subheader',
  });

  const onGetInstill = () => {
    window.open(`${env.VITE_CLIENT_BASE_URL}?hint=signup`, '_blank');
  };

  return (
    <div className={styles.container}>
      <BgGradientLeftIcon className={styles.bgGradientTop} />
      <BgGradientRightIcon className={styles.bgGradientBottom} />

      <header className={styles.header}>
        <a
          href={env.VITE_CLIENT_BASE_URL}
          target="_blank"
          rel="noreferrer"
          className={styles.logoLink}
          aria-label="Instill"
        >
          <img src={logoSource} alt="Instill" className={styles.logo} />
        </a>

        <Button onClick={onGetInstill}>{t('get-instill')}</Button>
      </header>

      <main className={styles.content}>{children}</main>
    </div>
  );
};

export default PublicMeetingShell;
